module.exports = new __parcel__URL__("checkedCircle.1cc2ecd3.svg").toString();